import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {catchError, map, reduce} from 'rxjs/operators';
import {Catalog} from '../models/catalog';
import {ContractOffer} from '../models/contract-offer';
import {
  ContractNegotiationService,
  TransferProcessService,
} from "../../mgmt-api-client";
import {CONNECTOR_CATALOG_API, CONNECTOR_MANAGEMENT_API} from "../../app/variables";
// import TypeEnum = Policy.TypeEnum; //TODO Use TypeEnum https://github.com/Think-iT-Labs/edc-connector-client/issues/103
import {
  ContractNegotiationRequest,
  ContractNegotiation,
  PolicyInput,
  TransferProcess,
  TransferProcessInput
} from "../../mgmt-api-client/model";




/**
 * Combines several services that are used from the {@link CatalogBrowserComponent}
 */
@Injectable({
  providedIn: 'root'
})
export class CatalogBrowserService {

  constructor(private httpClient: HttpClient,
              private transferProcessService: TransferProcessService,
              private negotiationService: ContractNegotiationService,
              @Inject(CONNECTOR_MANAGEMENT_API) private managementApiUrl: string,
              @Inject(CONNECTOR_CATALOG_API) private catalogApiUrl: string) {
  }

  getContractOffers(): Observable<ContractOffer[]> {
    let url = this.catalogApiUrl || this.managementApiUrl;
    //IDOIA: EDC 0.7.1
    //return this.post<Catalog[]>(url + "/federatedcatalog")
    return this.post<Catalog[]>(url + "/catalog/query")
      .pipe(map(catalogs => catalogs.map(catalog => {
        const arr = Array<ContractOffer>();
        //let datasets = catalog["dcat:dataset"];
        //URTZA let datasets = catalog["http://www.w3.org/ns/dcat#dataset"];
        //EDC 0.8.1
        let datasets = catalog["dcat:dataset"];
        if (!Array.isArray(datasets)) {
          datasets = [datasets];
        }

        for(let i = 0; i < datasets.length; i++) {
          const dataSet: any = datasets[i];
          const properties: { [key: string]: string; } = {
            id: dataSet["id"],
            name: dataSet["name"],
            version: dataSet["version"],
            type: dataSet["type"],
            contentType: dataSet["contenttype"]
          }
          const assetId = dataSet["@id"];

          //const hasPolicy = dataSet["odrl:hasPolicy"];
          let hasPolicy = dataSet["odrl:hasPolicy"];
          // Check if it is an array of objects
          if(Object.prototype.toString.call(dataSet["odrl:hasPolicy"]) === '[object Array]') {
            hasPolicy = dataSet["odrl:hasPolicy"][0];
          }


          //IDOIA: EDC 0.7.0
          //Convert permission object to valid permission for EDC 0.7.0
          //There could be 0 or several Permission-s
          //Check if odrl:permission is an array of objects
          if(Object.prototype.toString.call(hasPolicy["odrl:permission"]) === "[object Array]") {
             for(let i = 0; i < hasPolicy["odrl:permission"].length; i++) {
               for(let j = 0; j < hasPolicy["odrl:permission"][i]["odrl:constraint"].length; j++) {
                  let left_operand = hasPolicy["odrl:permission"][i]["odrl:constraint"][j]["odrl:leftOperand"];
                  if (typeof left_operand === "object") {
                    if (hasPolicy["odrl:permission"][i]["odrl:constraint"][j]["odrl:leftOperand"]["@id"] === "edc:timeInterval") {
                          hasPolicy["odrl:permission"][i]["odrl:constraint"][j]["odrl:leftOperand"] = "https://w3id.org/edc/v0.0.1/ns/timeInterval";
                    }
                  }
                }
              }
          } else {
             if (hasPolicy["odrl:permission"]["odrl:constraint"].length>0)
             {
               for(let j = 0; j < hasPolicy["odrl:permission"]["odrl:constraint"].length; j++) {
                  let left_operand = hasPolicy["odrl:permission"]["odrl:constraint"][j]["odrl:leftOperand"];
                  if (typeof left_operand === "object") {
                    if (hasPolicy["odrl:permission"]["odrl:constraint"][j]["odrl:leftOperand"]["@id"] === "edc:timeInterval") {
                          hasPolicy["odrl:permission"]["odrl:constraint"][j]["odrl:leftOperand"] = "https://w3id.org/edc/v0.0.1/ns/timeInterval";
                    }
                  }
                }
              }
              else{
                  console.log("entra por aqui no es left_operando un object")
                  if (hasPolicy["odrl:permission"]["odrl:constraint"]["odrl:leftOperand"]["@id"] === "edc:location")
                          hasPolicy["odrl:permission"]["odrl:constraint"]["odrl:leftOperand"] = "https://w3id.org/edc/v0.0.1/ns/location";
                  else if (hasPolicy["odrl:permission"]["odrl:constraint"]["odrl:leftOperand"]["@id"] === "edc:purpose")
                          hasPolicy["odrl:permission"]["odrl:constraint"]["odrl:leftOperand"] = "https://w3id.org/edc/v0.0.1/ns/purpose";


              }
          }


          const policy: PolicyInput = {
            //currently hardcoded to SET since parsed type is {"@policytype": "set"}
            //IDOIA: edc-connector-client version 0.4.0
            //"@type": "set", //TODO Use TypeEnum https://github.com/Think-iT-Labs/edc-connector-client/issues/103
            "@type": "Set",
            "@context" : "http://www.w3.org/ns/odrl.jsonld",
            "uid": hasPolicy["@id"],
            "assignee": hasPolicy["assignee"],
            "assigner": hasPolicy["assigner"],
            "obligation": hasPolicy["odrl:obligation"],
            "permission": hasPolicy["odrl:permission"],
            "prohibition": hasPolicy["odrl:prohibition"],
            "target": hasPolicy["odrl:target"]
          };

          const newContractOffer: ContractOffer = {
            assetId: assetId,
            properties: properties,
            "dcat:service": catalog["http://www.w3.org/ns/dcat#service"],
            "dcat:dataset": datasets,
            id: hasPolicy["@id"],
            originator: catalog["originator"],
            policy: policy,
            //IDOIA: edc-connector-client version 0.4.0
            //URTZA assigner: catalog["participantId"]
            //EDC 0.9.0
            assigner: catalog["dspace:participantId"]
          };

          arr.push(newContractOffer)
        }
        return arr;
      })), reduce((acc, val) => {
        for(let i = 0; i < val.length; i++){
          for(let j = 0; j < val[i].length; j++){
            acc.push(val[i][j]);
          }
        }
        return acc;
      }, new Array<ContractOffer>()));
  }

  initiateTransfer(transferRequest: TransferProcessInput): Observable<string> {
    return this.transferProcessService.initiateTransfer(transferRequest).pipe(map(t => t.id!))
  }

  getTransferProcessesById(id: string): Observable<TransferProcess> {
    return this.transferProcessService.getTransferProcess(id);
  }

  initiateNegotiation(initiate: ContractNegotiationRequest): Observable<string> {
    return this.negotiationService.initiateContractNegotiation(initiate).pipe(map(t => t.id!))
  }

  getNegotiationState(id: string): Observable<ContractNegotiation> {
    return this.negotiationService.getNegotiation(id);
  }

  private post<T>(urlPath: string,
                  params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>; })
    : Observable<T> {
    const url = `${urlPath}`;
    let headers = new HttpHeaders({"Content-type": "application/json"});
    //IDOIA: EDC 0.7.1
    //return this.catchError(this.httpClient.post<T>(url, "{\"edc:operandLeft\": \"\",\"edc:operandRight\": \"\",\"edc:operator\": \"\",\"edc:Criterion\":\"\"}", {headers, params}), url, 'POST');
    return this.catchError(this.httpClient.post<T>(url, "{\"@context\":{\"@vocab\": \"https://w3id.org/edc/v0.0.1/ns/\"},\"protocol\": \"dataspace-protocol-http\"}", {headers, params}), url, 'POST');
  }

  private catchError<T>(observable: Observable<T>, url: string, method: string): Observable<T> {
    return observable
      .pipe(
        catchError((httpErrorResponse: HttpErrorResponse) => {
          if (httpErrorResponse.error instanceof Error) {
            console.error(`Error accessing URL '${url}', Method: 'GET', Error: '${httpErrorResponse.error.message}'`);
          } else {
            console.error(`Unsuccessful status code accessing URL '${url}', Method: '${method}', StatusCode: '${httpErrorResponse.status}', Error: '${httpErrorResponse.error?.message}'`);
          }

          return EMPTY;
        }));
  }
}
